module.exports = __webpack_public_path__ + "img/game4.2.9aaf4a4f.png";